// extracted by mini-css-extract-plugin
export var chatHtmlText = "_q1-2";
export var chatLink = "_q1-0";
export var chatText = "_q1-1";